import { render, staticRenderFns } from "./PayeeRelatedDocuments.vue?vue&type=template&id=8ebc9caa"
import script from "./PayeeRelatedDocuments.vue?vue&type=script&lang=js"
export * from "./PayeeRelatedDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports